import React from 'react';
import { useTranslations } from 'next-intl';
import { cn } from '@wwe-portal/ui/lib/lib';
import { LoadingIcon } from '../../../../../packages/ui/components/icons/loading-icon';

function LoadAnimateButton({
  bodySize,
  hasText = true,
}: Readonly<{
  bodySize?: string;
  hasText?: boolean;
}>) {
  const t = useTranslations();
  return (
    <div className="flex items-center justify-center">
      <LoadingIcon />
      {hasText && (
        <span
          className={cn(
            'ml-1 pl-[5px] text-xs font-medium text-white',
            bodySize
          )}
        >
          {t('processing')}
        </span>
      )}
    </div>
  );
}

export default LoadAnimateButton;
